<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="850">
  <kendo-dialog-titlebar>
    <h3>{{ (isNew ? 'ADD-HELP-DOCUMENT' : 'EDIT-HELP-DOCUMENT') | translate }}</h3>
  </kendo-dialog-titlebar>
  <form novalidate [formGroup]="editForm" class="k-form">
    <div class="row">
      <div class="col-12">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'NAME' | translate}} *
          </span>
          <input id="name" kendoTextBox formControlName="name" maxlength="255" />
          <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('required') && name.touched">
            {{'REQUIRED-NAME' | translate}}
          </div>
          <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('nameExists')">
            {{'HELP-DOCUMENT-ALREADY-EXISTS' | translate}}
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'TYPE' | translate}} *
          </span>
          <div>
            <span>
              <input type="radio" value="DOCUMENT" name="type" formControlName="type" id="radioDocument"
                kendoRadioButton />
              <label class="k-radio-label" for="radioDocument" [ngClass]="{'k-disabled': type.disabled}">{{'DOCUMENT' |
                translate}}
              </label>
              <input type="radio" value="URL" name="type" formControlName="type" id="radioURL" kendoRadioButton />
              <label class="k-radio-label" for="radioURL" [ngClass]="{'k-disabled': type.disabled}">{{'URL' |
                translate}}
              </label>
              <div class="k-tooltip k-tooltip-validation" *ngIf="type.hasError('required') && type.touched">
                {{'REQUIRED-TYPE' | translate}}
              </div>
            </span>
          </div>
        </label>
      </div>
    </div>
    <div class="row" *ngIf="type.value === 'DOCUMENT'">
      <div class="col-9 pr-0">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'FILENAME' | translate}} *
          </span>
          <input id="importFilename" kendoTextBox formControlName="importFilename" [readonly]="true" />
          <input type="file" id="pdfFile" #pdfFileInput accept=".pdf" class="d-none"
            (change)="handlePdfInput($event.target.files)" />
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="importFilename.hasError('required') && importFilename.touched">
            {{'IMPORT-SELECT-FILE' | translate}}
          </div>
        </label>
      </div>
      <div class="col-3">
        <button appPreventClick kendoButton type="button" (click)="pdfFileInput.click()" class="float-right"
          style="margin-top:34px">
          {{'IMPORT-SELECT-FILE' | translate}}<i class="far fa-upload fa-white"></i>
        </button>
      </div>
    </div>
    <div class="row" *ngIf="type.value === 'URL'">
      <div class="col-12">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'URL' | translate}} *
          </span>
          <input id="url" kendoTextBox formControlName="url" maxlength="1000" />
          <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="url.hasError('required') && url.touched">
            {{'REQUIRED-LINK' | translate}}
          </div>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="!isValidUri(url) && url.hasError('pattern') && url.touched">
            {{'INVALID-URL' | translate}}
          </div>
        </label>
      </div>
    </div>
    <label class="k-text-uppercase dark mr-2 pt-2 w-100" for="enabled">{{ 'ENABLED' | translate }}</label>
    <kendo-switch formControlName="enabled" onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}">
    </kendo-switch>
  </form>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick class="k-button k-primary" (click)="onSave($event)">{{ 'SAVE' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>